export const endPoints = {
  COMPANY_TOKEN: '/v1/company/generate-token',
  ONE_C: '/v1/onec-config'
};
